import * as actionTypes from './actionTypes';

import type {
  ProfileAction,
} from '../types';

export const setProfileState = (
  keyOrRootValues: any,
  maybeValues?: any,
): ProfileAction => ({
  type: actionTypes.SET_PROFILE_STATE,
  payload: {
    keyOrRootValues,
    maybeValues,
  },
});

export const requestConnectProvider = (
  payload: number,
  provider: number,
) => ({
  type: actionTypes.REQUEST_CONNECT_PROVIDER,
  payload,
  provider,
});

export const requestUpdateUser = ({
  body,
  userId,
  callbacks,
}: {
  body: any,
  userId?: number,
  callbacks?: any,
}) => ({
  type: actionTypes.REQUEST_UPDATE_USER,
  body,
  userId,
  callbacks,
});

export const requestUpdateSettings = ({
  body,
  clientId,
  settingsId,
  callbacks,
}: {
  body: any,
  clientId?: number,
  settingsId: number,
  callbacks?: any,
}) => ({
  type: actionTypes.REQUEST_UPDATE_SETTINGS,
  body,
  clientId,
  settingsId,
  callbacks,
});
